import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer>
    <div className='flex border-t flex-col md:flex-row w-full py-8 items-end justify-between text-[14px] text-gray-700 dark:text-gray-500'>
    <div className="py-10">
			<div className="max-w-7xl py-10 px-5 md:p-0 space-y-5  mx-auto flex justify-between md:items-end flex-col md:flex-row">
				<div className="space-y-10">
					<div className="space-y-2 w-full sm:w-96">
						<Logo />
						<p className="">
							Explore a world of coding insights and knowledge on
							our blog website, where every article is a step
							towards mastering the art of programming and staying
							ahead in the dynamic tech landscape
						</p>
					</div>
				</div>
			</div>
      <p className="font-semibold">&copy; {new Date().getFullYear()} Flex. All rights reserved.</p>
      </div>
        <dir className='flex gap-5'>
          <Link to='/contact'>Contact</Link>
          <Link to='/'>Terms of Service</Link>
          <Link to='/' target='_blank'>
            Privacy Policy
          </Link>
        </dir>
      </div>
    </footer>
  );
};

export default Footer;
